/**
 * Display a clickable 8x8 grid
 *
 * @author: Vanessa Richie Alia-Trapero <vanessa@dividia.net>
 */

const MotionGridOverlay = (props) => {
  const {loading, error, grid, toggleGridItem} = props

  return (
    <div style={styles.gridContainer}>
      {loading
        ? <div style={styles.gridMessage}>Loading ...</div>
        : error
          ? <div style={styles.gridMessage}>Device Offline</div>
          : grid.map((item, index) => {
              return (
                <div key={index}
                    style={{ ...styles.gridItem, backgroundColor: item === '0' ? 'rgba(0,0,0,0.6)' : 'transparent' }}
                    onClick={() => toggleGridItem(index)}>
                </div>
              )
            })
      }
    </div>
  )
}

export default MotionGridOverlay

const styles = {
  gridContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    height: '100%',
    width: '100%',
    zIndex: 1,
    position: 'absolute',
    top: 0,
    left: 0
  },
  gridMessage: {
    width: '100%',
    margin: 2,
    padding: '1vmin',
    backgroundColor: 'rgba(0,0,0,0.8)',
    color: 'white',
    textAlign: 'center',
  },
  gridItem: {
    border: '1px solid black',
    width: '12.5%',
    height: '12.5%',
    boxSizing: 'border-box',
    cursor: 'pointer'
  }
}